import type { StaticImageData } from 'next/image';

import albertCascioImage from '../../../../../public/images/team/albert-cascio.png';
import alexLazinicaImage from '../../../../../public/images/team/alex-lazinica.png';
import andonBaltakovImage from '../../../../../public/images/team/andon-baltakov.png';
import craigOlsvikImage from '../../../../../public/images/team/craig-olsvik.png';
import damiraMirsic from '../../../../../public/images/team/damira-mrsic.png';
import darrellGunterImage from '../../../../../public/images/team/darrell-gunter.png';
import edwardBrailovskyImage from '../../../../../public/images/team/edward-brailovsky.png';
import jamesPhimisterImage from '../../../../../public/images/team/james-phimister.png';
import jernejMasnecImage from '../../../../../public/images/team/jernej-masnec.png';
import jodiBologneseImage from '../../../../../public/images/team/jodi-bolognese.png';
import jureMikuzImage from '../../../../../public/images/team/jure-mikuz.png';
import katheSweenyImage from '../../../../../public/images/team/kathe-sweeny.png';
import laurensGroenendijkImage from '../../../../../public/images/team/laurens-groenendijk.png';
import liamBullinghamImage from '../../../../../public/images/team/liam-bullingham.png';
import lukaSimicImage from '../../../../../public/images/team/luka-simic.png';
import mateoRozic from '../../../../../public/images/team/mateo-rozic.png';
import miaPecinaDraskovicImage from '../../../../../public/images/team/mia-pecina-draskovic.png';
import oliveraPeroliZodan from '../../../../../public/images/team/olivera-peroli-zodan.png';
import petraVizintin from '../../../../../public/images/team/petra-vizintin.png';
import rafaelGrabovica from '../../../../../public/images/team/rafael-grabovica.png';
import rafaelSidiImage from '../../../../../public/images/team/rafael-sidi.png';
import rickAndersonImage from '../../../../../public/images/team/rick-anderson.png';
import solRosenbergImage from '../../../../../public/images/team/sol-rosenberg.png';
import winifredMetzImage from '../../../../../public/images/team/winifred-metz.png';
import zacharyHayes from '../../../../../public/images/team/zachary-hayes.png';

export enum TeamGroupData {
  EXECUTIVE = 'executive',
  DIRECTORS = 'directors',
  ADVISERS = 'advisers',
}

export enum TeamMembers {
  ALEX_LAZINICA = 'alexlazinica',
  JERNEJ_MASNEC = 'jernejmasnec',
  EDWARD_BRAILOVSKY = 'edwardbrailovsky',
  SOL_ROSENBERG = 'solrosenberg',
  DARREL_GUNTER = 'darrelgunter',
  LUKA_SIMIC = 'lukasimic',
  MIA_PECINA_DRASKOVIC = 'miapecinadraskovic',
  RAFAEL_SIDI = 'rafaelsidi',
  LAURENS_GROENENDIJK = 'laurensgroenendijk',
  JURE_MIKUŽ = 'juremikuž',
  ZACHARY_HAYES = 'zacharayar',
  DAMIRA_MRSIC = 'damiramrsic',
  OLIVERA_PEROLI_ZODAN = 'oliveraperolizodan',
  PETRA_VIZINTIN = 'petravizintin',
  RAFAEL_GRABOVICA = 'rafaelgrabovica',
  MATEO_ROZIC = 'mateorozic',
}

export interface ITeamMember {
  name: string;
  title?: string;
  imagePath: StaticImageData;
  institution?: string;
  linkedInLink: string;
}

export const GroupMembersData: Record<TeamGroupData, Array<TeamMembers>> = {
  [TeamGroupData.EXECUTIVE]: [
    TeamMembers.JERNEJ_MASNEC,
    TeamMembers.SOL_ROSENBERG,
    TeamMembers.LUKA_SIMIC,
    TeamMembers.EDWARD_BRAILOVSKY,
    TeamMembers.DARREL_GUNTER,
    TeamMembers.ZACHARY_HAYES,
    TeamMembers.DAMIRA_MRSIC,
    TeamMembers.OLIVERA_PEROLI_ZODAN,
    TeamMembers.PETRA_VIZINTIN,
    TeamMembers.MIA_PECINA_DRASKOVIC,
    TeamMembers.RAFAEL_GRABOVICA,
    TeamMembers.MATEO_ROZIC,
  ],
  [TeamGroupData.DIRECTORS]: [TeamMembers.RAFAEL_SIDI, TeamMembers.LAURENS_GROENENDIJK, TeamMembers.JURE_MIKUŽ],
  [TeamGroupData.ADVISERS]: [TeamMembers.ALEX_LAZINICA],
};

export const TeamMembersData: Record<TeamMembers, ITeamMember> = {
  [TeamMembers.JERNEJ_MASNEC]: {
    name: 'Jernej Masnec',
    title: 'CEO',
    imagePath: jernejMasnecImage,
    linkedInLink: 'https://www.linkedin.com/in/jernej-masnec-658b475/',
  },
  [TeamMembers.ALEX_LAZINICA]: {
    name: 'Alex Lazinica',
    institution: 'Intech Open',
    imagePath: alexLazinicaImage,
    linkedInLink: 'https://www.linkedin.com/in/alex-lazinica-80605612/',
  },
  [TeamMembers.EDWARD_BRAILOVSKY]: {
    name: 'Edward Brailovsky',
    title: 'CTO',
    imagePath: edwardBrailovskyImage,
    linkedInLink: 'https://www.linkedin.com/in/edbrailovsky/',
  },
  [TeamMembers.SOL_ROSENBERG]: {
    name: 'Sol Rosenberg',
    title: 'CRO',
    imagePath: solRosenbergImage,
    linkedInLink: 'https://www.linkedin.com/in/solrosenberg/',
  },
  [TeamMembers.DARREL_GUNTER]: {
    name: 'Darrell Gunter',
    title: 'CBO',
    imagePath: darrellGunterImage,
    linkedInLink: 'https://www.linkedin.com/in/darrellwgunter/',
  },
  [TeamMembers.LUKA_SIMIC]: {
    name: 'Luka Simic',
    title: 'COO',
    imagePath: lukaSimicImage,
    linkedInLink: 'https://www.linkedin.com/in/luka-%C5%A1imi%C4%87-504728b0/',
  },
  [TeamMembers.MIA_PECINA_DRASKOVIC]: {
    name: 'Mia Pecina Draskovic',
    title: 'Head of Underline Originals',
    imagePath: miaPecinaDraskovicImage,
    linkedInLink: 'https://www.linkedin.com/in/mia-pecina-draskovic-b0254a3/',
  },
  [TeamMembers.RAFAEL_SIDI]: {
    name: 'Rafael Sidi',
    institution: 'Wolters Kluwer',
    imagePath: rafaelSidiImage,
    linkedInLink: 'https://www.linkedin.com/in/rafaelsidi/',
  },
  [TeamMembers.LAURENS_GROENENDIJK]: {
    name: 'Laurens Groenendijk',
    imagePath: laurensGroenendijkImage,
    institution: 'Dutch Founders Fund',
    linkedInLink: 'https://www.linkedin.com/in/happyinvestments/',
  },
  [TeamMembers.JURE_MIKUŽ]: {
    name: 'Jure Mikuž',
    imagePath: jureMikuzImage,
    institution: 'South Central Ventures',
    linkedInLink: 'https://www.linkedin.com/in/jurem/',
  },
  [TeamMembers.ZACHARY_HAYES]: {
    name: 'Zachary Hayes',
    imagePath: zacharyHayes,
    title: 'Consulting Director, Data Licensing',
    linkedInLink: 'https://www.linkedin.com/in/zachary-haynes-nyc/',
  },
  [TeamMembers.DAMIRA_MRSIC]: {
    name: 'Damira Mrsic',
    imagePath: damiraMirsic,
    title: 'Head of Digital Library & Senior Events Manager',
    linkedInLink: 'https://www.linkedin.com/in/mrsicdamira/',
  },
  [TeamMembers.OLIVERA_PEROLI_ZODAN]: {
    name: 'Olivera Peroli Zodan',
    imagePath: oliveraPeroliZodan,
    title: 'Senior Events Manager',
    linkedInLink: 'https://www.linkedin.com/in/olivera-peroli-%C5%BEodan/',
  },
  [TeamMembers.PETRA_VIZINTIN]: {
    name: 'Petra Vizintin',
    imagePath: petraVizintin,
    title: 'Head of User Experience',
    linkedInLink: 'https://www.linkedin.com/in/petra-vi%C5%BEintin-ba11711ba/',
  },
  [TeamMembers.RAFAEL_GRABOVICA]: {
    name: 'Rafael Grabovica',
    imagePath: rafaelGrabovica,
    title: 'Customer Success Manager',
    linkedInLink: 'https://www.linkedin.com/in/rafael-leopold-grabovica-314374211/',
  },
  [TeamMembers.MATEO_ROZIC]: {
    name: 'Mateo Rozic',
    imagePath: mateoRozic,
    title: 'Operations Manager',
    linkedInLink: 'https://www.linkedin.com/in/mrozic15/',
  },
};

// https://www.linkedin.com/in/petra-vi%C5%BEintin-ba11711ba/
// https://www.linkedin.com/in/mrsicdamira/
